import React from "react";
import { Tab, Tabs } from "react-studio-tabs";
import { ListView } from "../../components/listView/ListView";
import { useDataContext, useLocale } from "../../services/DataContext";
import { TopSideContent } from "../hypes/Hypes";

export interface ActorsPageProps {

}

export const ActorsPage: React.FC<ActorsPageProps> = () => {
  const l: any = useLocale();
  const content = useDataContext();
  return <div className="actors-page container">
    <TopSideContent
      title={l["actorsTitle"]}
      description={l["actorsDescription"]}
    />

    <Tabs className="hide-on-medium animate__animated animate__fadeIn">
      <Tab title={l["actors"]}>
        <ListView data={content.actors} />
      </Tab>
      <Tab title={l["directors"]}>
        <ListView data={content.directors} />
      </Tab>
    </Tabs>
    <div className="row hide-on-small animate__animated animate__fadeIn" style={{ marginTop: "3rem" }}>
      <div className="col actors-page__list">
        <h3>{l["actors"]}</h3>
        <ListView data={content.actors} />
      </div>
      <div className="col actors-page__list">
        <h3>{l["directors"]}</h3>
        <ListView data={content.directors} />
      </div>
    </div>
  </div>
}